import React, { useCallback } from 'react';
import * as yup from 'yup';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { TextInput } from '@/common/components/Inputs/index';

const initialValues = {
  email: '',
};

const ResetPassword = ({ onSubmit, children, sx, isPending = false }) => {
  const { t } = useTranslation();
  const validation = yup.object({
    email: yup
      .string()
      .email(t('Must be valid email address'))
      .required(t('This field is required')),
  });

  const methods = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
    resolver: yupResolver(validation),
    shouldUnregister: true,
    defaultValues: initialValues,
  });
  const { isDirty, isValid } = methods.formState;

  const handleSubmit = useCallback(
    methods.handleSubmit(async (form) => {
      await onSubmit(form);
    }),
    [methods, onSubmit]
  );

  return (
    <FormProvider {...methods}>
      <Box component="form" sx={sx} onSubmit={handleSubmit}>
        <TextInput
          name="email"
          label={t('Email')}
          inputProps={{
            maxLength: 50,
          }}
        />
        {children}
        <Button
          type="submit"
          variant="contained"
          fullWidth
          size="large"
          disabled={!isDirty || !isValid}
          sx={{ mt: 5 }}
          loading={isPending}
        >
          {t('Send instructions')}
        </Button>
      </Box>
    </FormProvider>
  );
};

export default ResetPassword;
